// src/components/Experience.js
import React from 'react';

// Helper to parse a date string "YYYY-MM-DD" as a local date.
const parseLocalDate = (dateStr) => {
  const parts = dateStr.split("-");
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // months are 0-indexed
  const day = parseInt(parts[2], 10);
  return new Date(year, month, day);
};

// Helper to format a date as "Aug 2022"
const formatDate = (dateStr) => {
  const date = parseLocalDate(dateStr);
  const options = { month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};

// Helper to compute duration between startDate and now,
// and format it as "X yrs Y mos"
const getDuration = (startDateStr) => {
  const startDate = parseLocalDate(startDateStr);
  const now = new Date();
  let totalMonths =
    (now.getFullYear() - startDate.getFullYear()) * 12 +
    (now.getMonth() - startDate.getMonth());
  if (now.getDate() < startDate.getDate()) {
    totalMonths--; // Adjust if the current day is less than the start day.
  }
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  let durationStr = "";
  if (years > 0) {
    durationStr += `${years} yr${years > 1 ? "s" : ""}`;
  }
  if (months > 0) {
    durationStr += `${years > 0 ? " " : ""}${months} mo${months > 1 ? "s" : ""}`;
  }
  return durationStr;
};

const experiences = [
  {
    id: 1,
    company: "Hybrid Hosting LLC",
    role: "Chief Executive Officer",
    employmentType: "Full-time",
    startDate: "2022-08-01", // August 2022
    description:
      "Founded Hybrid Hosting in August 2022 and developed the company from the ground up, growing it from zero clients to thousands. I have done everything from building servers to client acquisitions and worked on every rung of the ladder.",
    logo: "hybridsquare.png",
    url: "https://hybridhosting.co",
  },
  {
    id: 2,
    company: "BarnBills LLC",
    role: "Chief Executive Officer",
    employmentType: "Full-time",
    startDate: "2024-07-01", // July 2024
    description:
      "Building authentic solutions for the horse industry, creating tools that serve this community with genuine care and understanding of their unique needs.",
    logo: "barnbills.png",
    url: "#",
  },
  {
    id: 3,
    company: "The Provider Podcast",
    role: "Founder & Co-Host",
    employmentType: "Part-time",
    startDate: "2024-06-01", // June 2024
    description:
      "Together with my bud Leifur Steinn Gunnarsson, I host the Provider Podcast which aims to demystify the keyword lingo of the technology space such as \"Cloud\", \"AI\", \"Infrastructure as a Service\" and thoroughly explain what they mean with humane language.",
    logo: "theproviderpodcastsquare.png",
    url: "https://theproviderpodcast.net",
  },
  {
    id: 4,
    company: "UpPacket",
    role: "Chief Executive Officer",
    employmentType: "Part-time",
    startDate: "2023-05-01", // May 2023
    description:
      "I have been working deeply in physical networking hardware in combination with advanced software technology. Planned for release in late 2026. This includes handling investor relations.",
    logo: "uppacketsquare.png",
    url: "https://uppacket.com",
  },
];

const Experience = () => {
  return (
    <section id="experience" className="my-16">
      <h2 className="text-3xl font-bold text-white text-center mb-8">
        Experience
      </h2>
      {/* Timeline container with left border */}
      <div className="relative pl-16 border-l-2 border-gray-600">
        {experiences.map((exp) => (
          <div key={exp.id} className="mb-12 relative">
            {/* Clickable logo image as a square (no border) */}
            <div className="absolute -left-12 top-0">
              <a href={exp.url} target="_blank" rel="noopener noreferrer">
                <img
                  src={`/vendor/${exp.logo}`}
                  alt={exp.company}
                  className="w-10 h-10"
                />
              </a>
            </div>
            <div className="ml-4">
              <h3 className="text-xl font-bold text-white">{exp.company}</h3>
              <p className="text-gray-300">
                <span className="font-semibold">{exp.role}</span>
                {exp.employmentType && <span> · {exp.employmentType}</span>}
              </p>
              <p className="text-gray-400 text-sm">
                {formatDate(exp.startDate)} - Present · {getDuration(exp.startDate)}
              </p>
              {exp.description && (
                <p className="text-gray-300 mt-2">{exp.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;